module.exports = __webpack_public_path__ + "img/bannerPc-2-4.dc582410.png";